import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useSession } from './SessionProvider.js';
import { FullPageSpinner } from '../../components/FullPageSpinner.js';

/**
 * Guarda rotas autenticadas. Enquanto `loading`, mostra spinner full-page.
 * Sem sessão → redireciona para `/login` preservando a rota destino em
 * `location.state.from` (para redirecionar de volta após login).
 *
 * Uso em React Router:
 * ```tsx
 * <Route element={<RequireAuth />}>
 *   <Route path="/dashboard" element={<Dashboard />} />
 * </Route>
 * ```
 */
export function RequireAuth() {
  const { loading, session } = useSession();
  const location = useLocation();

  if (loading) return <FullPageSpinner />;
  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}
